import { resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "site-content" }
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-8 ml-md-auto mr-md-auto\"><div id=\"resova-wrapper\"></div><p class=\"text-center\"><img src=\"/img/sectigo.png\" alt=\"Secured by Sectigo\"></p></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")
  const _component_booking_details = _resolveComponent("booking-details")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_page_header, {
      image: "ladder",
      title: "Booking"
    }),
    _createVNode("main", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_booking_details, {
            voucherLink: true,
            location: _ctx.location
          }, null, 8, ["location"])
        ])
      ])
    ])
  ]))
}